import React from 'react';
import { Typography } from '@material-ui/core';
import AttachedGoods from '../AttachedGoods';
import PaySection from './PaySection';
import DeliveryPayment from '../../../components/Good/DeliveryPayment/DeliveryPayment';
import s from './PaySection.module.scss';

const PayCard = props => {
  const { id, goodData, t } = props;

  return (
    <div className={s.payCard}>
      <Typography className={s.title} color="primary">
        {t['В наличии']}
      </Typography>
      <PaySection id={id} />
      <AttachedGoods product={goodData} />
      <DeliveryPayment t={t} />
    </div>
  );
};

export default PayCard;
